<template>
    <div class="content">
        <Header :security="true"></Header>
      <div class="security-box">
        <router-view />
      </div>
    </div>
  </template>
   
  <script>
  import Header from '@/layout/Header';
  export default {
    components: { Header },
    data() {
      return {
        
      }
    },
    mounted(){

    },
    destroyed () {

    },
    watch:{

    },
    methods:{

    }
  }
  </script>
  
  
  <style lang="scss" scoped>
  .content {
    width: 100% !important;
  }
  .security-box {
    display: flex;
  }

  @media (min-width: $minWidth) and (max-width: $maxWidth) {

  }
  @media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .content{
      height: 100%;
    }
    .security-box{
      height: 100%;
    }
  }
  </style>